import { HttpClient } from '../../httpClient'
import { OpalApi } from '../../schema'

type UpdateStage = OpalApi<'UpdateStageV2', 200>

export const updateStage: UpdateStage = async (args = {}) => {
  const stageId = args.params?.path.stage_id

  if (typeof stageId !== 'string') {
    throw new Error('Must supply a valid stage_id.')
  }

  const url = new URL(`/workflows/v2/stages/${stageId}`, window.location.origin)

  return HttpClient()
    .patch(url.toString(), args.requestBody)
    .then((res) => res.data)
}
